import { useEffect, useState } from "react";

const useLocationAccess = (t) => {
    const [userLocation, setUserLocation] = useState(null);
    const [locationError, setLocationError] = useState(null);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    setUserLocation({
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude,
                    });
                },
                (err) => {
                    console.error("خطأ في الحصول على الموقع:", err);
                    setLocationError(t.locationAccessDenied);
                }
            );
        } else {
            setLocationError("خاصية تحديد الموقع غير مدعومة في هذا المتصفح.");
        }
    }, []);

    return { userLocation, locationError };
};

export default useLocationAccess;